// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b3b01202","488":"14270323","732":"0905a398","977":"44e933d3"}[chunkId] + ".chunk.js";
};